import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import FAQ from "./FAQ";
import Language from "./Lang";
import { checkMobile, produrl, textMapping } from "../utils/helper";
import html2canvas from "html2canvas";
import S3 from "aws-sdk/clients/s3";
import AWS from "aws-sdk/global";
import moment from "moment";
import { QRCodeSVG } from "qrcode.react";

import { initializeApp } from "firebase/app";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import NativeShare from "../Common/NativeShare";
import Share from "../Common/Share";
import Loader from "../Popup/Loader";
import "./Referstyle.css";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB5pcUfpjn7n0CF3CCB9sKhvho92Q8vEe4",
  authDomain: "bjp-mem.firebaseapp.com",
  projectId: "bjp-mem",
  storageBucket: "bjp-mem-staging",
  messagingSenderId: "24775571254",
  appId: "1:24775571254:web:22eab6f8238f3cd1846597",
  measurementId: "G-2SJTJ43SRQ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

const Refer = () => {
  const [name, setName] = useState("");
  const [qrdata, setQrdata] = useState("");
  const [member, setMember] = useState("");
  const [memberid, setMemberid] = useState("");
  const [profile, setProfile] = useState("");
  const [datejoin, setDatejoin] = useState("");
  const [sharelink, setSharelink] = useState("");
  const [stateval, setStateval] = useState("");
  const [refcode, setRefcode] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const [loading, setLoading] = useState(false);
  const [popupData, setPopupData] = useState({});
  const [finalcanvas, setFinalcanvas] = useState("");
  const [canvasKey, setCanvasKey] = useState("");
  const [originalKey, setOriginalKey] = useState("");
  const [bucketUrl, setBucketUrl] = useState("");
  const [canvasimage, setCanvasimage] = useState("");
  const [freshlang, setFreshlang] = useState("");
  const [bloburl, setBloburl] = useState("");
  const [refcount, setRefcount] = useState("");
  const [isBlobUrlLoading, setIsBlobUrlLoading] = useState(false);
  const location = useLocation();
  const h4Ref = useRef(null);
  const navigate = useNavigate();

  const { refnum } = useParams();

  const bucketname = "js-sdk-bucket";
  AWS.config.region = "ap-south-1"; // Region
  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: "ap-south-1:84027705-475d-4ca1-bac8-b2eb7407ae9f",
  });
  const bucket = new AWS.S3({
    params: {
      Bucket: bucketname,
    },
  });

  // useEffect(() => {
  //   if (localStorage.getItem("canvasimage")) {
  //     setCanvasimage(localStorage.getItem("canvasimage"));
  //   }
  // });
  useEffect(() => {
    initialize();
    let token = localStorage.getItem("acesss");
    const refresh = localStorage.getItem("refresh");
    if (!token && !refresh) {
      if (refnum) {
        navigate("/" + refnum + window.location.search);
      } else {
        navigate("/" + window.location.search);
      }
    }
  }, []);

  const initialize = () => {
    let date = moment().format("DD-MM-yyyy");
    var sessionid = Date.now();
    localStorage.setItem("sessionid", sessionid);

    var bucketUrlkey =
      "https://s3.ap-south-1.amazonaws.com/" + date + "/" + bucketname + "/";
    var canvaskey =
      "bjpmembership2024/" +
      date +
      "/canvas_" +
      Math.floor(100000 + Math.random() * 900000) +
      localStorage.getItem("sessionid") +
      ".jpg";
    var originalkey =
      "bjpmembership2024/original_" +
      localStorage.getItem("sessionid") +
      ".jpg";

    setCanvasKey(canvaskey);
    setOriginalKey(originalkey);
    setBucketUrl(bucketUrlkey);
  };

  useEffect(() => {
    getFetchdetail();
    getReferralcount();
  }, []);

  const getFetchdetail = async () => {
    const url = `${produrl}api/v1/pm/details`;
    const options = {
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("acesss"),
      },
    };

    try {
      const response = await fetch(url, options);
      const data = await response.json();
      localStorage.setItem("sharelink", data.data.sharable_link);
      // localStorage.setItem("constituency_name", data.data.assembly_constituency_name);
      setName(data.data.name);
      setQrdata(data.data.qr_data);
      setMember(data.data.masked_membership_id);
      setMemberid(data.data.membership_id);
      setProfile(data.data.photo);
      setDatejoin(data.data.date_of_joining);
      setRefcode(data.data.referral_code);
      let link = data.data.sharable_link;

      link = link
        ? link.replace(
            "https://nm-4.com/bjpmem/",
            "https://www.narendramodi.in/bjpsadasyata2024/"
          )
        : "";
      setSharelink(link);
      setStateval(data.data.state_name);
    } catch (error) {
      console.error(error);
    }
  };

  const getReferralcount = async () => {
    const url = `${produrl}api/v1/pm/referral_count`;
    const form = new FormData();

    const options = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("acesss"),
      },
    };

    options.body = form;

    try {
      const response = await fetch(url, options);
      const data = await response.json();
      setRefcount(data.referral_count);
      localStorage.setItem("referral_count", data.referral_count);
    } catch (error) {
      console.error(error);
    }
  };

  const getImageBase64 = async (imageUrl) => {
    try {
      const response = await fetch(
        `${produrl}api/v1/pm/get_profile_photo_as_base64`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("acesss")}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            image_url: imageUrl,
          }),
        }
      );

      const data = await response.json();

      return data.data;
    } catch (error) {
      console.error("Error getting base64 image:", error);
      return imageUrl;
    }
  };

  const generateCanvas = async () => {
    let canvasimage = localStorage.getItem("canvasimage");
    if (window.location.href.indexOf("appversion") < 0) {
      setLoading(true);
      setIsBlobUrlLoading(true);
      window.scrollTo(0, 0);

      try {
        const base64Image = await getImageBase64(profile);
        setBloburl(base64Image);

        const img = new Image();
        img.crossOrigin = "anonymous";
        img.src = `data:image/png;base64,${base64Image}`;

        await new Promise((resolve) => {
          img.onload = resolve;
        });

        const canvasDiv = document.querySelector("#generate_canvas_div");
        const profileImg = canvasDiv.querySelector(".sad_img");
        if (profileImg) {
          profileImg.src = `data:image/png;base64,${base64Image}`;
        }

        await new Promise((resolve) => setTimeout(resolve, 100));

        html2canvas(canvasDiv, {
          width: 1200,
          height: 750,
          scale: 1,
          useCORS: true,
          allowTaint: true,
          logging: true,
          onclone: (clonedDoc) => {
            const clonedImg = clonedDoc.querySelector(".sad_img");
            if (clonedImg) {
              clonedImg.src = `data:image/png;base64,${base64Image}`;
            }
          },
        }).then(async (canvas) => {
          canvas.toBlob(async (blob) => {
            if (blob) {
              const blobUrl = URL.createObjectURL(blob);
              setLoading(false);
              setIsBlobUrlLoading(false);
              const link = document.createElement("a");
              link.href = blobUrl;
              link.download = "id_card.jpg";
              link.click();
              try {
                let obj = {};
                window.gtag("event", `Download Successfully`, obj);
              } catch (error) {}
            }
          }, "image/jpeg");
        });
      } catch (error) {
        console.error("Error generating canvas:", error);
        setLoading(false);
        setIsBlobUrlLoading(false);
      }
    } else {
      if (canvasimage) {
        saveData(canvasimage);
      } else {
        setLoading(true);
        setIsBlobUrlLoading(true);
        window.scrollTo(0, 0);

        try {
          const base64Image = await getImageBase64(profile);
          setBloburl(base64Image);

          const img = new Image();
          img.crossOrigin = "anonymous";
          img.src = `data:image/png;base64,${base64Image}`;

          await new Promise((resolve) => {
            img.onload = resolve;
          });

          const canvasDiv = document.querySelector("#generate_canvas_div");
          const profileImg = canvasDiv.querySelector(".sad_img");
          if (profileImg) {
            profileImg.src = `data:image/png;base64,${base64Image}`;
          }

          await new Promise((resolve) => setTimeout(resolve, 100));

          html2canvas(canvasDiv, {
            width: 1200,
            height: 750,
            scale: 1,
            useCORS: true,
            allowTaint: true,
            logging: true,
            onclone: (clonedDoc) => {
              const clonedImg = clonedDoc.querySelector(".sad_img");
              if (clonedImg) {
                clonedImg.src = `data:image/png;base64,${base64Image}`;
              }
            },
          }).then(async (canvas) => {
            canvas.toBlob(async (blob) => {
              if (blob) {
                var file = new File([blob], "filename");
                const blobUrl = URL.createObjectURL(blob);
                setBloburl(blobUrl);
                uploadToS3(file, "canvas", bucket, saveData);
                setLoading(false);
                setIsBlobUrlLoading(false);
              }
            }, "image/jpeg");
          });
        } catch (error) {
          console.error("Error generating canvas:", error);
          setLoading(false);
          setIsBlobUrlLoading(false);
        }
      }
    }
  };

  const uploadToS3 = (file, type, bucket, callback) => {
    var objKey = null;
    if (type === "canvas") {
      objKey = canvasKey;
    } else if (type === "original") {
      objKey = originalKey;
    }

    var params = {
      Key: objKey,
      ContentType: file.type ? file.type : "image/jpeg",
      Body: file,
      ACL: "public-read",
    };
    if (!callback) {
      callback = (err, data) => {};
    }
    bucket.putObject(params, callback);
  };

  const saveData = (canvasimage, blob) => {
    let alias_url = "https://campaign-images.narendramodi.in/";

    let imageurl = canvasimage ? canvasimage : alias_url + canvasKey;
    localStorage.setItem("canvasimage", imageurl);
    setFinalcanvas(imageurl);
    if (canvasimage) {
      console.log("data uploaded", canvasimage);
    } else {
      console.log("new image upload", imageurl);
    }
    if (window.location.href.indexOf("appversion") != -1) {
      let encodedurl = encodeURIComponent(`${imageurl}?ignore.zip`);
      let downlaodUrl = `download://?url=${encodedurl}`;
      window.location.href = downlaodUrl;
      try {
        let obj = {};
        window.gtag("event", `Download Successfully`, obj);
      } catch (error) {}
    }
  };

  const handleCopy = async () => {
    if (h4Ref.current) {
      if (window.location.href.indexOf("appversion") != -1) {
        try {
          await navigator.clipboard.writeText(sharelink);
        } catch (err) {
          console.error("Failed to copy text: ", err);
        }
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = h4Ref.current.textContent || ""; // Get the text content of the <h4>
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
      setShowMessage(true);
      setTimeout(() => {
        setShowMessage(false);
      }, 2000);
      try {
        let obj = {};
        window.gtag("event", `Referral Copy Successfully`, obj);
      } catch (error) {}
    }
  };

  const handleShare = () => {
    let link = localStorage.getItem("sharelink");

    link = link
      ? link.replace(
          "https://nm-4.com/bjpmem/",
          "https://www.narendramodi.in/bjpsadasyata2024/"
        )
      : "";
    const message = `Greetings, I have become a primary member of the BJP. You too can join the Party using my referral link : ${link} #BJPSadasyata2024`;
    // const message = `Namaskar 🙏🏻\nI have become a primary member under the BJP's Primary Membership Campaign. You can also join through my referral link.\n\nReferral link: ${sharelink}\n\nThank you🪷🪷`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/?text=${encodedMessage}&ignore.zip`;
    window.open(whatsappUrl, "_blank");
    try {
      let obj = {};
      window.gtag("event", `Referral Share Successfully`, obj);
    } catch (error) {}
  };
  const setLanguval = (lang) => {
    setFreshlang(lang);
  };
  const openSharePopup = (val) => {
    if (val) {
      setPopupData(val);
      setShowShare(true);
    }
  };
  const closeSharePopup = () => {
    setShowShare(false);
  };

  const editbutton = () => {
    localStorage.setItem("useredit", true);
    navigate("/home" + window.location.search);
  };
  const logout = () => {
    localStorage.clear();

    setTimeout(() => {
      if (refnum) {
        navigate("/" + refnum + window.location.search);
      } else {
        navigate("/" + window.location.search);
      }
      window.location.reload();
    }, 200);
  };
  return (
    <>
      {loading && <Loader />}
      <div className="faqbg_wid">
        <div className="faq_bg">
          <div className="lang_headerbg">
            <div className="member_container">
              <div className="lang_header">
                <div className="janta_part_flex">
                  <img
                    src="/assets/images/bjplogonew.png"
                    className="bjplogo"
                    alt="BJPL Logo"
                  />
                  <h6>{textMapping("Bharatiya Janata Party")}</h6>
                </div>
                <Language freshlang={setLanguval} />
              </div>
            </div>
          </div>
          <div className="member_container">
            <div className="refeupda_top">
              <NavLink
                // to={`https://staging.primarymemberdrive.com/nm-redirect?language=${localStorage.getItem(
                // to={`https://prod-pm-drive.bjp.org/nm-redirect?language=${localStorage.getItem(
                // to={`https://prodtestmem24.bjp.org/membership/nm-redirect?language=${localStorage.getItem(
                // to={`https://staging-pm-drive.bjp.org/membership/nm-redirect?language=${localStorage.getItem(
                to={`${produrl}nm-redirect?language=${localStorage.getItem(
                  "language"
                )}&access_token=${localStorage.getItem(
                  "acesss"
                )}&refresh_token=${localStorage.getItem("refresh")}`}
                target="_blank"
                className="update_detail_btn"
              >
                {textMapping("Update your details")}
              </NavLink>
              <p className="updaterefer_p">
                {textMapping(
                  "Click above to add more details, donate and add other members to BJP"
                )}
              </p>
              <NavLink
                className="update_detail_btn"
                to={`${produrl}nm-redirect?language=en&target_path=activemembership&access_token=${localStorage.getItem(
                  // to={`https://staging-pm-drive.bjp.org/membership/nm-redirect?language=en&target_path=activemembership&access_token=${localStorage.getItem(
                  // to={`https://prodtestmem24.bjp.org/membership/nm-redirect?language=en&target_path=activemembership&access_token=${localStorage.getItem(
                  "acesss"
                )}&refresh_token=${localStorage.getItem("refresh")}`}
              >
                Pay for Active membership
              </NavLink>
              <a
                className="update_detail_btn"
                href={`${produrl}nm-redirect?language=en&target_path=download80g&access_token=${localStorage.getItem(
                  // href={`https://staging-pm-drive.bjp.org/membership/nm-redirect?language=en&target_path=download80g&access_token=${localStorage.getItem(
                  // href={`https://prodtestmem24.bjp.org/membership/nm-redirect?language=en&target_path=download80g&access_token=${localStorage.getItem(
                  "acesss"
                )}&refresh_token=${localStorage.getItem("refresh")}&ignore.zip`}
                target="_blank"
                rel="noreferrer"
              >
                Download Payment Slip
              </a>
            </div>

            <h2 className="idleft">
              {textMapping("Share Your Referral Link")}
            </h2>

            {/* <div className="refer_card">
              <img
                src="/assets/images/referbg.png"
                className="refer_img"
                alt=""
              />
              <div className="refer_flex">
                <div className="refer_codebg">
                  <h4 ref={h4Ref}>
                    <u>{sharelink}</u>
                  </h4>

                  <button onClick={handleCopy}>
                    <img src="/assets/images/copy.png" alt="" />
                  </button>
                </div>

                <div className="sharebtnwid">
                  <button className="sharewhatsapp" onClick={handleShare}>
                    {textMapping("Share")}
                    <img src="/assets/images/whatsapp.png" alt="" />
                  </button>
                </div>
              </div>
            </div> */}

            <div className="referlink_brd">
              <h4 ref={h4Ref} className="referlinkdet">
                <u>{sharelink}</u>
              </h4>

              <button className="copy_link" onClick={handleCopy}>
                copy
              </button>
            </div>

            <h4 className="refcode_head" style={{ padding: "15px 0px" }}>
              Your Referral Code :{" "}
              <span>
                <u>{refcode}</u>
              </span>
            </h4>

            <button
              className="sharelin_btn"
              onClick={handleShare}
              style={{ marginBottom: "20px" }}
            >
              <img src="/assets/images/sharewhite.svg" alt="" />{" "}
              {textMapping("Share")}
            </button>
            {/* <div className="people_join">
              {refcount > 0 && (
                <p>
                  Total number of people joined using your referral code:{" "}
                  <span>{refcount}</span>
                </p>
              )}
            </div> */}

            <div className="copy_pos" style={{ minHeight: "auto" }}>
              <div
                className="copy_height"
                style={{ transform: "translate(-50%, -50%)", marginTop: "0px" }}
              >
                {showMessage && <div className="copy-message">Copied</div>}
              </div>
            </div>
            {refcount > 0 && (
              <>
                <div
                  className="refer_count_div"
                  style={{ paddingBottom: "0px" }}
                >
                  <h4 className="ref_count_head">Your Referral Count</h4>
                  <NavLink
                    to={"/referlist" + window.location.search}
                    className="refer_dir"
                  >
                    <ul className="ref_count_list">
                      <li>
                        <h5>Referral Count</h5>
                        <h3>{refcount}</h3>
                      </li>
                      <li>
                        <img src="/assets/images/arrowrightblack.png" alt="" />
                      </li>
                    </ul>
                  </NavLink>
                </div>
              </>
            )}
            {/* 
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              {window.location.href.indexOf("appversion") != -1 ? (
                <>
                  <a href="appclick://cancel" className="ghome">
                    Home
                  </a>
                  <a
                    className="ghome"
                    onClick={() => {
                      logout();
                    }}
                  >
                    Log out
                  </a>
                </>
              ) : (
                <a
                  className="ghome"
                  onClick={() => {
                    logout();
                  }}
                  style={{ marginLeft: "auto" }}
                >
                  Log out
                </a>
              )}
            </div> */}

            <div className="card_head">
              <div className="memb_cente_id" style={{ paddingTop: "30px" }}>
                <h2>{textMapping("Membership Card")}</h2>
                <h4>
                  Membership Number : <span>{memberid}</span>{" "}
                </h4>
                {datejoin && (
                  <h5>
                    Date of Joining : <span>{datejoin}</span>
                  </h5>
                )}
              </div>
              <div className="member_edit_flex">
                {/* <h2 className="idleft">{textMapping("Membership Card")}</h2> */}
                <button className="editcard" onClick={editbutton}>
                  <img src="/assets/images/edit.svg" alt="" /> Edit
                </button>
              </div>
              <div className="image_template_div">
                <img
                  src="/assets/images/canvascard.png"
                  className="card_template_img"
                  alt=""
                />
                <img
                  src={profile ? profile : "/assets/images/userdefault.jpg"}
                  className="card_template_userimg"
                  alt=""
                />
                <h4 className="usertem_name" style={{ height: "auto" }}>
                  {name ? name : ""}
                </h4>
                <h4 className="usertem_state" style={{ height: "auto" }}>
                  {stateval ? stateval : ""}
                </h4>
                <h4 className="usertem_number">{member ? member : ""}</h4>
                <div className="qr_card_template">
                  <QRCodeSVG
                    className="barcode_template"
                    fgColor={"#D56336"}
                    value={qrdata}
                    style={{ background: "none" }}
                  />
                </div>
              </div>
            </div>

            <ul className="sharerefler_social">
              {/* <li>
                <NavLink to="">
                  <img src="/assets/images/whstsshare.svg" alt="" />
                </NavLink>
              </li> */}
              {checkMobile() != "desktop" && (
                <li className="sharepad_flex">
                  <NativeShare
                    openPopup={openSharePopup}
                    closePopup={closeSharePopup}
                    item={sharelink}
                    key={"i"}
                    showShare={showShare}
                  >
                    <img src="/assets/images/sharerefer.svg" alt="" />
                  </NativeShare>
                </li>
              )}

              <li>
                <button onClick={generateCanvas}>
                  <img src="/assets/images/downloadshare.svg" alt="" />
                </button>
              </li>
            </ul>

            <ul className="homelogut_btn">
              {/* <li>
                <button className="home_btn">Home</button>
              </li> */}

              {window.location.href.indexOf("appversion") != -1 ? (
                <>
                  <li>
                    <a href="appclick://cancel" className="home_btn">
                      Home
                    </a>
                  </li>

                  <li>
                    <a
                      className="logout_btn"
                      onClick={() => {
                        logout();
                      }}
                    >
                      Logout
                    </a>
                  </li>
                </>
              ) : (
                <li style={{ width: "100%" }}>
                  <a
                    className="logout_btn"
                    onClick={() => {
                      logout();
                    }}
                    // style={{ marginLeft: "auto" }}
                  >
                    Logout
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      <div
        id="generate_canvas_div"
        style={{
          height: "auto",
          position: "fixed",
          float: "none",
          left: "-10000px",
          top: "-1000000px",
        }}
      >
        <div className="canvas_section sadyastacard">
          <img
            src={profile ? profile : "/assets/images/userdefault.jpg"}
            className="sad_img"
            alt=""
          />
          <h4 className="sadas_name" style={{ height: "auto" }}>
            {name ? name : ""}
          </h4>
          <h4 className="sadas_state" style={{ height: "auto" }}>
            {stateval ? stateval : ""}
          </h4>
          <h4 className="sadas_number">{member ? member : ""}</h4>
          <div className="qr_card">
            <QRCodeSVG
              className="barcode"
              fgColor={"#D56336"}
              value={qrdata}
              style={{ background: "none" }}
            />
          </div>
        </div>
      </div>
      {showShare && <Share closeShare={closeSharePopup} item={finalcanvas} />}
    </>
  );
};

export default Refer;
